/**
 * The History surface: the programme's history, whichever editor base it is
 * reached from.
 *
 * @module router/programme-editor/HistoryRoute
 */

import React, { useMemo } from "react";

import { useParams } from "react-router";

import { ProgrammeHistory } from "@/components/history/ProgrammeHistory";
import { NamesUnavailableAlert } from "@/components/shared/NamesUnavailableAlert";
import { useWorkspaceOutletContext } from "@/router/workspace-context";

export function HistoryRoute(): React.ReactElement {
  const { programmeId = "" } = useParams<{ programmeId: string }>();
  const {
    client,
    platformUsers,
    platformProgrammes,
    platformModules,
    platformDataError,
    refreshPlatformWorkspace,
  } = useWorkspaceOutletContext();
  const moduleNames = useMemo(
    () =>
      new Map(
        platformModules
          .filter((row) => row.programmeId === programmeId)
          .map((row) => [
            row.moduleId,
            { title: row.moduleTitle, programmeTitle: row.programmeTitle },
          ]),
      ),
    [platformModules, programmeId],
  );
  const programmeTitle =
    platformProgrammes.find((programme) => programme.id === programmeId)?.title ?? "";
  return (
    <>
      {platformDataError ? (
        <NamesUnavailableAlert
          onRetry={refreshPlatformWorkspace}
          data-testid="history-names-error"
        />
      ) : null}
      <ProgrammeHistory
        // Keyed on the programme, so its filters and pages do not carry to another.
        key={programmeId}
        client={client}
        programmeId={programmeId}
        programmeTitle={programmeTitle}
        users={platformUsers}
        moduleNames={moduleNames}
      />
    </>
  );
}
